import React, {useRef, useState} from 'react'
import bem from '../../helpers/bem'
import './style.scss'
import {getActiveOption} from "../../helpers/common";
import {useOuterClick} from "../../hooks/common";

const block = 'choose-dropdown';

const ChooseDropdown = (props) => {
  const {
    options,
    game,
    players,
    setOption,
  } = props;
  const [open, setOpen] = useState(false);
  const dropdownBlock = useRef(null);

  useOuterClick(() => setOpen(false), dropdownBlock);

  const takeActiveOption = () => {
    const activeOption = getActiveOption(options);
    return activeOption ? activeOption.name : false
  };

  const getDropdownMods = () => {
    return {
      'players': !!players,
      'game': !!game,
      'open': open,
    };
  };

  return (
    <div
      className={bem({block, mods: getDropdownMods()})}
      ref={dropdownBlock}
      onClick={() => setOpen(!open)}
    >
      <div className={bem({block, elem: 'active'})}>
        {takeActiveOption()}
      </div>
      {open && (
        <div className={bem({block, elem: 'items'})}>
          {options.map(option => {
            const optionId = option.id;
            return !option.active && (
              <div
                key={optionId}
                className={bem({block, elem: 'option'})}
                onClick={() => setOption(optionId)}
              >
                {option.name}
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
};

export default ChooseDropdown;